import React, {useRef, useState} from "react";
import Dump from "../react/helpers/dump";
import {useForm} from 'react-hook-form';
import classNames from 'classnames';
import Spinner from "../react/helpers/spinner";

export default function Contact(props) {
	const mode = props.mode ? props.mode : 'contact';
	const [isSent, setIsSent] = useState(false);

	const {register, handleSubmit, formState: { errors, isSubmitting}, reset} = useForm();
	const form = useRef(null)

	function inputClass(error = false) {
		const staticClasses = 'text-black focus:ring-opacity-50 focus:outline-1';
		return classNames(staticClasses, (error ? 'focus:border-red focus:ring-red border-1 border-red' : 'focus:border-purple focus:ring-purple'));
	}

	return (
		<>
			<span/>
			<form ref={form} onSubmit={handleSubmit(onSubmit)}>
				<div className="mb-4">
					<label className="mb-2 inline-block" htmlFor="email">Email</label><br/>
					<input
						// defaultValue="tst@gfdgsd.pl"
						className={classNames('w-full lg:w-2/3', inputClass(errors.email))}
					    type="email" id="email" name="email" size="20" {...register("email", {required: true, pattern: /^\S+@\S+$/i})}/>
				</div>
				<div className="mb-4">
					<label className="mb-2 inline-block" htmlFor="tel">Telefon</label><br/>
					<input
						// defaultValue="789789789"
						className={classNames('w-full lg:w-2/3', inputClass(errors.telephone))}
						type="tel" id="tel" name="tel" size="20" {...register("telephone", {required: true, maxLength: 12})}/>
				</div>
				<div className="mb-4">
					<label className="mb-2 inline-block" htmlFor="company">{mode == 'contact' ? 'Firma' : 'Name' }</label><br/>
					<input
						className={classNames('w-full lg:w-2/3', inputClass(errors.company))}
						type="text" id="company" name="company" size="20" {...register("company", {})}/>
				</div>
				<div className="mb-4">
					<label className="mb-2 inline-block" htmlFor="enquiry">Wiadomość</label><br/>
					<textarea
						// defaultValue="Message"
						className={classNames('w-full', inputClass(errors.enquiry))}
					    id="enquiry" name="textarea" rows="8" {...register("enquiry", {required: true})}></textarea>
				</div>

				<button disabled={isSubmitting} className={classNames("mr-6 px-5 py-3 text-white transition-all", isSubmitting ? 'bg-blueIsh-300' : 'bg-blackAlmost')} type="submit">
					{isSubmitting ? 'Wysyłam' : 'Wyślij'}
					{isSubmitting && <Spinner width/>}
				</button>
				{isSent && <span onClick={() => setIsSent(false)}>Odezwiemy się najszybciej jak to możliwe</span>}
			</form>
		</>
	);

	function resetForm() {
		reset({
			email: '',
			telephone: '',
			company: '',
			enquiry: ''
		});
	}

	function onSubmit() {
		setIsSent(false);

		const data = new FormData(form.current);
		data.append('mode', mode);

		return fetch('/process.php', {
			method: "POST",
			body: data
		}).then(() => { setIsSent(true); resetForm(); });
	}
}
